var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelphone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0501 25.4333L27.8167 24.95C27.319 24.8915 26.8144 24.9466 26.341 25.1112C25.8676 25.2757 25.4376 25.5454 25.0834 25.9L22.0167 28.9667C17.2857 26.5599 13.4402 22.7143 11.0334 17.9833L14.1167 14.9C14.8334 14.1833 15.1834 13.1833 15.0667 12.1667L14.5834 7.96667C14.4893 7.15348 14.0992 6.40337 13.4875 5.85932C12.8758 5.31527 12.0854 5.01533 11.2667 5.01667H8.3834C6.50007 5.01667 4.9334 6.58333 5.05007 8.46667C5.9334 22.7 17.3167 34.0667 31.5334 34.95C33.4167 35.0667 34.9834 33.5 34.9834 31.6167V28.7333C35.0001 27.05 33.7334 25.6333 32.0501 25.4333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelphone);
export default __webpack_public_path__ + "static/media/telphone.a13c5bb304e5c97350a479cf4fddfaea.svg";
export { ForwardRef as ReactComponent };